import {
  Button,
  Row,
  Col,
  OverlayTrigger,
} from "react-bootstrap";
import React from "react";
import "./MarketplaceCard.scss";
import { Link, useHistory } from "react-router-dom";
import { getTemplateDetail } from "../../../actions/marketplace-action";
import { connect } from "react-redux";
import { trimString } from "../../../utils/Utils";

const MarketplaceCard = (props) => {
  //console.log(props)
  const {template,getTemplateDetail,t,featured} = props;
  const back_test = template.back_test || {};
  const history = useHistory(); 
  const clickTemplateDetails = (id)=>{
    history.push(`/marketplace-detail/${id}`)
  }
  return (
    <div className="marketplace-card">
      <div className="pos-relative template-img-div">
      {featured && <>
        <i className="fas fa-crown featured-icon"></i>
        <span className="featured-text">Featured</span>
        </> }
        <img src={template.image} className="marketplace-bot-img img-thumbnail no-border"></img>
      </div>
      <div className="create-bot">
        <Row>
          <ul className="marketplac-card-info">
            <li>
              <div className="marketplace-card-title">{trimString(template.title,50) }</div>
              <div><span className={template.strategy=="Long"?"long":"short"}>{template.strategy}</span></div>
            </li>
            <li>
              <div>APY</div>
              <div>{template.apy}%</div>
            </li>
            <li>
              <div>{t("w-l-ratio")}</div>
              <div>{template.wl_ratio}%</div>
            </li>
            <li>
              <div>{t("rent")}</div>
              <div>US${template.monthly_fee} /{t("month")}</div>
            </li>
            {/* <li>
              <div>Current Renters</div>
              <div>{template.current_renter}</div>
            </li> */}
          </ul>
        </Row>
        <Link to={`/marketplace-detail/${template.id}`}><Button variant="success" className="w-100 mt-2 btn-primary">
          {t("vd")}
        </Button></Link>
      </div>
    </div>
  );
};

export default connect(null,{getTemplateDetail})(MarketplaceCard);
